import React from 'react';
import {Layout} from 'react-admin';
import TripsetAppBar from './TripsetAppBar';
import TripsetMenu from "./TripsetMenu";

const TripsetLayout = (props) => <Layout {...props} appBar={TripsetAppBar} menu={TripsetMenu}/>;

export default TripsetLayout;
